/**
 * EducationCategoryNav — sticky sub-nav rendered on every
 * /education/* page so users always know where they are.
 */
import { Link, NavLink } from "react-router-dom";
import { GraduationCap, Building2, Award, Home } from "lucide-react";

const TABS = [
  { to: "/education",              key: "home",         label: "Home",           icon: Home,       exact: true },
  { to: "/education/institutions", key: "institutions", label: "Institutions",   icon: Building2 },
  { to: "/education/scholarships", key: "scholarships", label: "Scholarships",   icon: Award },
];

export default function EducationCategoryNav() {
  return (
    <nav
      className="sticky top-0 z-20 backdrop-blur-md border-b overflow-x-auto"
      style={{ background: "rgba(253,251,247,0.85)", borderColor: "var(--wofy-border)" }}
      data-testid="education-nav"
    >
      <div className="max-w-6xl mx-auto flex items-center gap-1 px-3 py-2">
        <Link to="/education" className="inline-flex items-center gap-1 text-xs opacity-70 hover:opacity-100 pr-2 md:pr-3 border-r"
              style={{ borderColor: "var(--wofy-border)" }} data-testid="education-nav-brand">
          <GraduationCap className="w-3.5 h-3.5" /> Education
        </Link>
        {TABS.map(({ to, key, label, icon: Icon, exact }) => (
          <NavLink
            key={key} to={to} end={exact}
            className={({ isActive }) =>
              `whitespace-nowrap inline-flex items-center gap-1 text-xs px-2.5 py-1.5 rounded-full transition ${
                isActive ? "bg-black text-white" : "hover:bg-black/5"
              }`
            }
            data-testid={`education-nav-${key}`}
          >
            <Icon className="w-3.5 h-3.5" />{label}
          </NavLink>
        ))}
      </div>
    </nav>
  );
}
